// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-popover>.trigger[data-v-8f1c4576]>{z-index:1}.icon-info[data-v-8f1c4576]{background-image:var(--icon-info-000)}.app-content-list-item[data-v-8f1c4576]:hover{background:transparent}.button[data-v-8f1c4576]{background-color:var(--color-main-background);width:44px;height:44px;border:0;margin-bottom:17px}.button[data-v-8f1c4576]:hover,.button[data-v-8f1c4576]:focus{background-color:var(--color-background-dark)}\n", ""]);
// Exports
module.exports = exports;
